export default "__VITE_ASSET__BWi8M6hJ__"